import HeartRating from './heart-rating'

export default HeartRating
